import React from 'react';
import { FlexGrid, Paper, Skeleton, Stacker, TypographyBody, TypographyHeading } from '@honeycomb/ui-core';
function RoomRadioCardSkeleton() {
    return (React.createElement(Paper, { radius: "s", border: 1, p: 4 },
        React.createElement(FlexGrid, { container: true, spacing: 4 },
            React.createElement(FlexGrid, { xs: 12, m: 4 },
                React.createElement(Paper, { radius: "s", overflow: "hidden" },
                    React.createElement(Skeleton, { h: 180 }))),
            React.createElement(FlexGrid, { xs: "fill", p: { xs: 4, m: 0 } },
                React.createElement(FlexGrid, { container: true, spacing: 4, flexDirection: { xs: 'column', m: 'row' } },
                    React.createElement(FlexGrid, { xs: "fill" },
                        React.createElement(TypographyHeading, { size: "s", mb: 4, color: "text.body" },
                            React.createElement(Skeleton, { variant: "text", w: "60%" })),
                        React.createElement(Stacker, { spacing: 2 }, ['50%', '40%', '60%'].map((width) => {
                            return (React.createElement(TypographyBody, { component: "div", size: "xs", key: width },
                                React.createElement(Skeleton, { variant: "text", w: width })));
                        }))),
                    React.createElement(FlexGrid, { xs: "hold" },
                        React.createElement(TypographyBody, { component: "div" },
                            React.createElement(Skeleton, { variant: "text", w: 100 }))))),
            React.createElement(FlexGrid, null,
                React.createElement(Skeleton, { variant: "circle", w: 20, h: 20 })))));
}
export function RoomOptionGroupSkeleton({ numberOfRooms }) {
    return (React.createElement(Stacker, { spacing: 12 }, [...Array(numberOfRooms).keys()].map((key) => {
        return (React.createElement(Stacker, { spacing: 4, key: key },
            React.createElement(TypographyHeading, { size: "s", color: "text.body" },
                React.createElement(Skeleton, { variant: "text", w: 140 })),
            [...Array(2).keys()].map((key2) => {
                return React.createElement(RoomRadioCardSkeleton, { key: key2 });
            })));
    })));
}
